"use client";

import type { HomepageSsrBootstrap } from "@/providers/HomepageSsrProvider";
import BeemoApp from "../../../src/BeemoApp";
import MasterclassLandingPage from "../../../src/features/masterclasses/pages/MasterclassLandingPage";

export function MasterclassPageApp({
  bootstrap,
}: {
  bootstrap: HomepageSsrBootstrap;
}) {
  return (
    <BeemoApp
      bootstrap={bootstrap}
      ssrMasterclassPageElement={<MasterclassLandingPage />}
    />
  );
}
